/** Entrance markers are painted on the floor, below even a flat booth roof. */
export const VENUE_MAP_ENTRANCE_DOT_HEIGHT = 0.02;
export const VENUE_MAP_ENTRANCE_DOT_RADIUS = 2.8;
export const VENUE_MAP_ENTRANCE_DOT_COLOR = "#5e8477";

/** The same floor-plane circle feeds both projected SVG and WebGL geometry. */
export function mapEntranceDotPoints(entrance: { x: number; y: number }) {
  return Array.from({ length: 32 }, (_, index) => {
    const angle = (index * Math.PI * 2) / 32;
    return {
      x: entrance.x + Math.cos(angle) * VENUE_MAP_ENTRANCE_DOT_RADIUS,
      y: entrance.y + Math.sin(angle) * VENUE_MAP_ENTRANCE_DOT_RADIUS,
      z: VENUE_MAP_ENTRANCE_DOT_HEIGHT,
    };
  });
}
